let setConfig = _ => {};
let AdComponent = () => {
  return null;
};

if (__CLIENT__) {
  setConfig = require('ad-react-wrapper').setConfig;
  AdComponent = require('ad-react-wrapper').default;
}
export { setConfig };

export default AdComponent;
